export default {"src":"/_next/static/media/instagram.365075d4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};